import {
  createSlice,
  createAsyncThunk,
} from "@reduxjs/toolkit";

import axios from "axios";

// ============================================================
// API BASE URL
// ============================================================

const BASE_URL =
  process.env.REACT_APP_BACKEND_BASE_URL ||
  "http://localhost:5000/api";

console.log(
  "🟢 ONLINE STATUS BASE URL:",
  BASE_URL
);

// ============================================================
// AXIOS INSTANCE
// ============================================================

const api = axios.create({
  baseURL: `${BASE_URL}/business`,
});

// ============================================================
// TOKEN INTERCEPTOR
// ============================================================

api.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("token") ||
      localStorage.getItem("accessToken");

    console.log(
      "======================================"
    );

    console.log(
      "🔐 ONLINE STATUS REQUEST"
    );

    console.log(
      "Token:",
      token
        ? "TOKEN FOUND"
        : "NO TOKEN FOUND"
    );

    console.log(
      "URL:",
      `${config.baseURL}${config.url}`
    );

    console.log(
      "Method:",
      config.method
    );

    console.log(
      "======================================"
    );

    if (token) {
      config.headers.Authorization =
        `Bearer ${token}`;
    }

    return config;
  },
  (error) =>
    Promise.reject(error)
);

// ============================================================
// UPDATE ONLINE STATUS
// ============================================================

export const updateOnlineStatus =
  createAsyncThunk(
    "businessOnlineStatus/updateOnlineStatus",

    async (
      { userId, isOnline },
      { rejectWithValue }
    ) => {
      try {
        console.log(
          "======================================"
        );

        console.log(
          "🟢 UPDATE ONLINE STATUS"
        );

        console.log(
          "Business User ID:",
          userId
        );

        console.log(
          "Requested isOnline:",
          isOnline
        );

        console.log(
          "======================================"
        );

        // ====================================================
        // VALIDATE USER ID
        // ====================================================

        if (!userId) {
          return rejectWithValue({
            success: false,
            message:
              "Business user ID is required.",
          });
        }

        // ====================================================
        // VALIDATE STATUS
        // ====================================================

        if (
          typeof isOnline !==
          "boolean"
        ) {
          return rejectWithValue({
            success: false,
            message:
              "isOnline must be a boolean value.",
          });
        }

        // ====================================================
        // API REQUEST
        // ====================================================

        const response =
          await api.put(
            "/online-status",
            {
              userId,
              isOnline,
            }
          );

        // ====================================================
        // API SUCCESS
        // ====================================================

        console.log(
          "======================================"
        );

        console.log(
          "✅ ONLINE STATUS API SUCCESS"
        );

        console.log(
          "Response:",
          response.data
        );

        console.log(
          "Backend isOnline:",
          response.data
            ?.user
            ?.isOnline
        );

        console.log(
          "======================================"
        );

        return response.data;

      } catch (error) {
        console.error(
          "======================================"
        );

        console.error(
          "❌ ONLINE STATUS API ERROR"
        );

        console.error(
          "Status:",
          error.response?.status
        );

        console.error(
          "Response:",
          error.response?.data
        );

        console.error(
          "Message:",
          error.message
        );

        console.error(
          "======================================"
        );

        return rejectWithValue(
          error.response?.data || {
            success: false,
            message:
              "Unable to update online status.",
          }
        );
      }
    }
  );

// ============================================================
// INITIAL STATE
// ============================================================

const initialState = {
  isOnline: false,
  updatingStatus: false,
  statusError: null,
};

// ============================================================
// SLICE
// ============================================================

const onlineStatusSlice =
  createSlice({
    name:
      "businessOnlineStatus",

    initialState,

    reducers: {
      // ======================================================
      // CLEAR ERROR
      // ======================================================

      clearBusinessUserError:
        (state) => {
          state.statusError = null;
        },

      // ======================================================
      // SET STATUS MANUALLY
      // ======================================================

      setOnlineStatus:
        (state, action) => {
          state.isOnline =
            Boolean(
              action.payload
            );

          console.log(
            "🟢 MANUAL REDUX STATUS:",
            state.isOnline
          );
        },
    },

    extraReducers: (builder) => {
      builder

        // ====================================================
        // PENDING
        // ====================================================

        .addCase(
          updateOnlineStatus.pending,
          (state) => {
            state.updatingStatus =
              true;

            state.statusError =
              null;
          }
        )

        // ====================================================
        // SUCCESS
        // ====================================================

        .addCase(
          updateOnlineStatus.fulfilled,
          (
            state,
            action
          ) => {
            state.updatingStatus =
              false;

            const backendStatus =
              action.payload
                ?.user
                ?.isOnline;

            console.log(
              "======================================"
            );

            console.log(
              "✅ REDUX FULFILLED"
            );

            console.log(
              "Payload:",
              action.payload
            );

            console.log(
              "Backend isOnline:",
              backendStatus
            );

            console.log(
              "Current Redux isOnline:",
              state.isOnline
            );

            // ================================================
            // IMPORTANT
            // ================================================

            if (
              typeof backendStatus ===
              "boolean"
            ) {
              state.isOnline =
                backendStatus;
            }

            state.statusError =
              null;

            console.log(
              "NEW Redux isOnline:",
              state.isOnline
            );

            console.log(
              "======================================"
            );
          }
        )

        // ====================================================
        // ERROR
        // ====================================================

        .addCase(
          updateOnlineStatus.rejected,
          (
            state,
            action
          ) => {
            state.updatingStatus =
              false;

            state.statusError =
              action.payload || {
                success: false,
                message:
                  "Unable to update online status.",
              };

            console.error(
              "❌ REDUX ONLINE STATUS FAILED:",
              action.payload
            );
          }
        );
    },
  });

// ============================================================
// ACTIONS
// ============================================================

export const {
  clearBusinessUserError,
  setOnlineStatus,
} =
  onlineStatusSlice.actions;

// ============================================================
// SELECTORS
// ============================================================

export const selectIsOnline =
  (state) =>
    Boolean(
      state
        .businessOnlineStatus
        ?.isOnline
    );

export const selectUpdatingStatus =
  (state) =>
    Boolean(
      state
        .businessOnlineStatus
        ?.updatingStatus
    );

export const selectStatusError =
  (state) =>
    state
      .businessOnlineStatus
      ?.statusError || null;

// ============================================================
// REDUCER
// ============================================================

export default onlineStatusSlice.reducer;